import { LayoutComponent } from './layouts/layout/layout.component';
import { VexRoutes } from '@vex/interfaces/vex-route.interface';
import { authGuard } from './pages/auth/auth.guard';
import { menuAccessChildGuard } from './pages/auth/menu-access.guard';
import { SalesInvoicePrintComponent } from './pages/erp/sales/print/sales-invoice-print/sales-invoice-print.component';
import { PurchaseOrderPrintComponent } from './pages/erp/purchase/print/purchase-order-print/purchase-order-print.component';
import { PurchaseBillPrintComponent } from './pages/erp/purchase/print/purchase-bill-print/purchase-bill-print.component';
import { MaterialRequestPrintComponent } from './pages/erp/store/print/material-request-print/material-request-print.component';
import { MaterialIssuePrintComponent } from './pages/erp/store/print/material-issue-print/material-issue-print.component';
import { MaterialTransferPrintComponent } from './pages/erp/store/print/material-transfer-print/material-transfer-print.component';
import { GrnPrintComponent } from './pages/erp/store/print/grn-print/grn-print.component';
import { PaymentAdvicePrintComponent } from './pages/erp/finance/print/payment-advice-print/payment-advice-print.component';
import { ReceiptPrintComponent } from './pages/erp/finance/print/receipt-print/receipt-print.component';
import { JournalVoucherPrintComponent } from './pages/erp/finance/print/journal-voucher-print/journal-voucher-print.component';
import { ContraPrintComponent } from './pages/erp/finance/print/contra-print/contra-print.component';
import { CreditNotePrintComponent } from './pages/erp/finance/print/credit-note-print/credit-note-print.component';
import { DebitNotePrintComponent } from './pages/erp/finance/print/debit-note-print/debit-note-print.component';

export const appRoutes: VexRoutes = [
  {
    path: 'head-office/client-control',
    loadComponent: () => import('./pages/erp/admin/client-control/client-control-admin.component')
      .then(m => m.ClientControlAdminComponent),
    canActivate: [authGuard]
  },
  {
    path: 'report-render/qac-checklist-report',
    loadComponent: () =>
      import('./pages/erp/qac/reports/qac-checklist-report/backend-report-render/qac-checklist-report-backend-render.component').then(
        (m) => m.QacChecklistReportBackendRenderComponent
      ),
    data: { reportRender: true }
  },
  {
    path: 'report-render/qac-feedback-report',
    loadComponent: () =>
      import(
        './pages/erp/qac/reports/qac-feedback-report/backend-report-render/qac-feedback-report-backend-render.component'
      ).then(
        m => m.QacFeedbackReportBackendRenderComponent
      ),
    data: {
      reportRender: true
    }
  },
   {
    path: 'report-render/adhoc_report',
    loadComponent: () =>
      import(
        './pages/erp/qac/reports/qac_adhoc_report/backend-report-render/qac_adhoc_report.component_backend_report_render'
      ).then(
        m => m.QacAdhocReportBackendRenderComponent
      ),
    data: {
      reportRender: true
    }
  },
  {
    path: 'sales/invoice/invoice-print/:id',
    component: SalesInvoicePrintComponent,
    canActivate: [authGuard]
  },
  {
    path: 'purchase/purchaseorder/print/:id',
    component: PurchaseOrderPrintComponent,
    canActivate: [authGuard]
  },
  {
    path: 'purchase/purchasebill/print/:id',
    component: PurchaseBillPrintComponent,
    canActivate: [authGuard]
  },
  {
    path: 'store/materialrequest/print/:id',
    component: MaterialRequestPrintComponent,
    canActivate: [authGuard]
  },
  {
    path: 'store/materialissue/print/:id',
    component: MaterialIssuePrintComponent,
    canActivate: [authGuard]
  },
  {
    path: 'store/materialtransfer/print/:id',
    component: MaterialTransferPrintComponent,
    canActivate: [authGuard]
  },
  {
    path: 'store/grnmaster/print/:id',
    component: GrnPrintComponent,
    canActivate: [authGuard]
  },
  {
    path: 'finance/payment/print/:id',
    component: PaymentAdvicePrintComponent,
    canActivate: [authGuard]
  },
  {
    path: 'finance/receipt/print/:id',
    component: ReceiptPrintComponent,
    canActivate: [authGuard]
  },
  {
    path: 'finance/voucher/print/:id',
    component: JournalVoucherPrintComponent,
    canActivate: [authGuard]
  },
  {
    path: 'finance/contra/print/:id',
    component: ContraPrintComponent,
    canActivate: [authGuard]
  },
  {
    path: 'finance/creditnote/print/:id',
    component: CreditNotePrintComponent,
    canActivate: [authGuard]
  },
  {
    path: 'finance/debitnote/print/:id',
    component: DebitNotePrintComponent,
    canActivate: [authGuard]
  },
  {
    path: 'feedback/public/thank-you',
    loadComponent: () =>
      import('./pages/erp/qac/feedback/feedback-public-thank-you/feedback-public-thank-you.component').then(
        (m) => m.FeedbackPublicThankYouComponent
      )
  },
  {
    path: 'feedback/public',
    pathMatch: 'full',
    loadComponent: () =>
      import('./pages/erp/qac/feedback/feedback-public/feedback-public.component').then(
        (m) => m.FeedbackPublicComponent
      )
  },
  {
    path: 'login',
    loadComponent: () =>
      import('./pages/auth/login/login.component').then(
        (m) => m.LoginComponent
      )
  },
  {
    path: 'register',
    loadComponent: () =>
      import('./pages/auth/register/register.component').then(
        (m) => m.RegisterComponent
      )
  },
  {
    path: 'forgot-password',
    loadComponent: () =>
      import(
        './pages/auth/forgot-password/forgot-password.component'
      ).then((m) => m.ForgotPasswordComponent)
  },
  {
    path: 'reset-password',
    loadComponent: () =>
      import(
        './pages/auth/reset-password/reset-password.component'
      ).then((m) => m.ResetPasswordComponent)
  },
  {
    path: 'coming-soon',
    loadComponent: () =>
      import('./pages/coming-soon/coming-soon.component').then(
        (m) => m.ComingSoonComponent
      )
  },
  {
    path: 'access-denied',
    loadComponent: () =>
      import('./pages/access-denied/access-denied.component').then(
        (m) => m.AccessDeniedComponent
      )
  },
  {
    path: '',
    component: LayoutComponent,
    canActivateChild: [menuAccessChildGuard],
    children: [{
      path: 'dashboards/analytics',
      loadComponent: () =>
        import(
          './pages/dashboards/dashboard-analytics/dashboard-analytics.component'
        ).then((m) => m.DashboardAnalyticsComponent), canActivate: [authGuard],

    },
    {
      path: 'dashboards/salesdashboard',
      loadComponent: () =>
        import(
          './pages/dashboards/salesdashboard/salesdashboard.component'
        ).then((m) => m.SalesdashboardComponent), canActivate: [authGuard]
    },
    {
      path: '',
      loadComponent: () =>
        import(
          './pages/dashboards/dashboard-analytics/dashboard-analytics.component'
        ).then((m) => m.DashboardAnalyticsComponent), canActivate: [authGuard]
    },
    {
      path: 'admin',
      loadChildren: () => import('../app/pages/erp/admin/admin.module')
        .then(m => m.AdminModule), canActivate: [authGuard]
    },
    {
      path: 'attendance',
      loadChildren: () => import('../app/pages/hrms/attendance/attendance.module')
        .then(m => m.AttendanceModule), canActivate: [authGuard]
    },
    {
      path: 'dms',
      loadChildren: () => import('../app/pages/dms/dms/dms.module')
        .then(m => m.DmsModule), canActivate: [authGuard]
    },
    {
      path: 'employees',
      loadChildren: () => import('../app/pages/hrms/employees/employees.module')
        .then(m => m.EmployeesModule), canActivate: [authGuard]
    },
    {
      path: 'finance',
      loadChildren: () => import('../app/pages/erp/finance/finance.module')
        .then(m => m.FinanceModule), canActivate: [authGuard]
    },
    {
      path: 'leave',
      loadChildren: () => import('../app/pages/hrms/leave/leave.module')
        .then(m => m.LeaveModule), canActivate: [authGuard]
    },
    {
      path: 'payroll',
      loadChildren: () => import('../app/pages/hrms/payroll/payroll.module')
        .then(m => m.PayrollModule), canActivate: [authGuard]
    },
    {
      path: 'production',
      loadChildren: () => import('../app/pages/erp/production/production.module')
        .then(m => m.ProductionModule), canActivate: [authGuard]
    },
    {
      path: 'purchase',
      loadChildren: () => import('../app/pages/erp/purchase/purchase.module')
        .then(m => m.PurchaseModule), canActivate: [authGuard]
    },
    {
      path: 'sales',
      loadChildren: () => import('../app/pages/erp/sales/sales.module')
        .then(m => m.SalesModule), canActivate: [authGuard]
    },
    {
      path: 'store',
      loadChildren: () => import('../app/pages/erp/store/store.module')
        .then(m => m.StoreModule), canActivate: [authGuard]
    },
    {
      path: 'qac',
      loadChildren: () => import('../app/pages/erp/qac/qac.module')
        .then(m => m.QacModule), canActivate: [authGuard]
    },
    ]
  }
];
